import { UtilityService } from "./index";

class NewSampleRequestServices {

  async newsamplerequest(page) {
    let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/exportss', {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      },
      body: JSON.stringify({
        page: page
      })
    });
    return {
      text: await result.json(),
      status: result.status,
    };
  }

  // async newsamplerequest() {
  //   let result = await fetch(
  //     UtilityService.baseUrl() + "api/sampleRequest/exportss",
  //     {
  //       method: "GET",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         AuthToken: localStorage.getItem("authToken")
  //       }
  //     }
  //   );
  //   return {
  //     status: result.status,
  //     text: await result.json()
  //   };
  // }

  async newsamplerequestsearch(moduleName, id) {
    let result = await fetch(UtilityService.baseUrl() + `api/sampleRequest/exportss?requestNumber=${id}`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      }
    });
    return {
      status: result.status,
      text: await result.json()
    }
  }

  
  async newsamplerequestUser(id) {
    let result = await fetch(UtilityService.baseUrl() + `api/sampleRequest/progress/${id}`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      }
    });
    return {
      status: result.status,
      text: await result.json()
    }
  }

}
export default new NewSampleRequestServices();



// WEBPACK FOOTER //
// ./src/services/newsamplerequest.service.js